// VF ACTIONS - Complete Translations for 10 Languages
// Languages: FR, EN, ES, DE, IT, PT, NL, BR (Breton), PL, RU

const translations = {
  fr: {
    // Navigation
    nav: {
      dashboard: 'Tableau de bord',
      actualites: 'Actualités',
      pricing: 'Tarifs',
      admin: 'Admin',
      login: 'Se connecter',
      register: "S'inscrire",
      logout: 'Déconnexion',
    },
    // Hero Section
    hero: {
      badge: 'VF ACTIONS - L\'IA au service des territoires',
      title1: 'L\'IA au service',
      title2: 'des territoires',
      subtitle: 'Nous accompagnons les collectivités, PME et associations dans l\'adoption de l\'intelligence artificielle.',
      subtitleAccent: 'Simple. Humain. Concret.',
      cta: 'Découvrir notre approche',
      ctaLogin: 'Accéder au Dashboard',
      // Titre principal - Slogan territorial
      heroTitle1: 'L\'IA au service',
      heroTitle2: 'des territoires',
      // Message secondaire - Bénéfice client clair
      heroSubtitle: 'Gagnez du temps, optimisez vos ressources et concentrez-vous sur l\'essentiel.',
      heroSubtitleAccent: 'Simple. Rapide. Efficace.',
      ctaStart: 'Créer ma stratégie',
      ctaDiscover: 'Découvrir',
      // Stats restaurées
      statCreations: 'créations',
      statTrees: 'arbres plantés',
      statSatisfied: 'satisfaits',
      // Badge territorial discret
      aiService: "L'IA au service des territoires",
      // Differentiators (gardés pour compatibilité)
      diffHuman: 'Accompagnement humain',
      diffResults: 'Résultats mesurables',
      diffSimple: 'Adoption simple',
      // CTAs avec emojis restaurés
      ctaCreateStrategy: '✨ Créer ma stratégie marketing',
      ctaDashboard: '🚀 Accéder au Dashboard PRO',
      ctaNewStrategy: '✨ Nouvelle stratégie',
      ctaMyProjects: 'Mes Projets',
      ctaHaveAccount: 'J\'ai déjà un compte',
      ctaSubtext: 'Gratuit • Sans engagement • Résultats en quelques minutes',
      // Audience chips (gardés pour compatibilité)
      chipCollectivities: 'Collectivités',
      chipAssociations: 'Associations',
      chipPME: 'PME',
      chipProjects: 'Porteurs de projets',
      statTerritories: 'territoires accompagnés',
      statOrganizations: 'organisations',
      statSatisfaction: 'de satisfaction',
    },
    // Auth Modal
    auth: {
      loginTitle: 'Connexion',
      registerTitle: 'Créer un compte',
      email: 'Email',
      password: 'Mot de passe',
      name: 'Nom complet',
      forgotPassword: 'Mot de passe oublié ?',
      loginBtn: 'Se connecter',
      registerBtn: "S'inscrire",
      switchToRegister: 'Créer un compte',
      switchToLogin: 'Se connecter',
      orContinueWith: 'Ou continuer avec',
      googleLogin: 'Google',
      passwordRequirements: '8+ caractères, majuscule, minuscule, chiffre',
      loginSuccess: 'Connexion réussie !',
      registerSuccess: 'Compte créé ! Vérifiez votre email.',
      loginError: 'Erreur de connexion',
      registerError: "Erreur d'inscription",
    },
    // Dashboard
    dashboard: {
      welcome: 'Bienvenue',
      credits: 'Crédits',
      plan: 'Plan',
      generate: 'Générer du Contenu',
      history: 'Historique',
      templates: 'Modèles',
      contentType: 'Type de contenu',
      topic: 'Sujet',
      tone: 'Ton',
      wordCount: 'Nombre de mots',
      industry: 'Industrie',
      instructions: 'Instructions supplémentaires',
      generateBtn: 'Générer',
      generating: 'Génération en cours...',
      result: 'Résultat',
      copy: 'Copier',
      save: 'Sauvegarder',
      noCredits: 'Plus de crédits disponibles',
    },
    // Content Types
    contentTypes: {
      blog: 'Article de Blog',
      social: 'Post Réseaux Sociaux',
      email: 'Email Marketing',
      ad: 'Publicité',
      description: 'Description Produit',
    },
    // Tones
    tones: {
      professional: 'Professionnel',
      casual: 'Décontracté',
      formal: 'Formel',
      friendly: 'Amical',
      persuasive: 'Persuasif',
    },
    // Pricing
    pricing: {
      title: 'Tarifs Simples et Transparents',
      subtitle: 'Choisissez le plan qui vous convient',
      free: 'Découverte',
      starter: 'Starter',
      pro: 'Pro',
      enterprise: 'Entreprise',
      perMonth: '/mois',
      credits: 'crédits',
      features: 'Fonctionnalités',
      choosePlan: 'Choisir',
      currentPlan: 'Plan actuel',
      popular: 'Populaire',
    },
    // News/Actualités
    news: {
      title: "Centre d'Actualités",
      newFeatures: 'Nouveautés',
      tips: 'Astuces Marketing',
      rse: 'RSE & Écologie',
      share: 'Partager',
      loading: 'Chargement...',
    },
    // Admin
    admin: {
      title: 'Administration',
      stats: 'Statistiques',
      users: 'Utilisateurs',
      analytics: 'Analytics',
      totalUsers: 'Utilisateurs totaux',
      totalRevenue: 'Revenus totaux',
      mrr: 'MRR',
      arr: 'ARR',
      churn: 'Taux de churn',
      ltv: 'LTV',
      arpu: 'ARPU',
      manageUser: 'Gérer',
    },
    // Common
    common: {
      loading: 'Chargement...',
      error: 'Erreur',
      success: 'Succès',
      cancel: 'Annuler',
      save: 'Sauvegarder',
      delete: 'Supprimer',
      edit: 'Modifier',
      close: 'Fermer',
      back: 'Retour',
      next: 'Suivant',
      yes: 'Oui',
      no: 'Non',
      or: 'ou',
    },
    // Footer
    footer: {
      rights: 'Tous droits réservés',
      privacy: 'Confidentialité',
      terms: 'Conditions',
      tagline: 'L\'IA au service des territoires.',
      description: 'VF ACTIONS accompagne les collectivités, associations et PME dans l\'adoption de l\'intelligence artificielle, avec une approche simple, humaine et orientée résultats.',
      badges: '100% Made in France • Accompagnement humain • RGPD',
      navTitle: 'Navigation',
      navHome: 'Accueil',
      navApproach: 'Notre Approche',
      navCreateStrategy: 'Créer ma stratégie',
      navPricing: 'Tarifs',
      navNews: 'Actualités',
      legalTitle: 'Légal',
      legalMentions: 'Mentions légales',
      legalCGU: 'CGU',
      legalPrivacy: 'Politique de confidentialité',
      legalRGPD: 'RGPD',
      copyright: 'VF Actions — L\'IA au service des territoires. Tous droits réservés.',
    },
    // Testimonials Section - Masquée, prête à activer
    // Pour activer: mettre showTestimonials à true dans le code
    testimonials: {
      sectionLabel: '— Témoignages',
      sectionTitle: 'Ils nous font confiance',
      sectionSubtitle: 'Découvrez les retours de nos clients.',
      placeholder: 'Les témoignages seront ajoutés au fur et à mesure des retours réels de nos utilisateurs.',
      // Exemples de structure pour futurs témoignages
      items: [
        {
          name: 'Nom du client',
          role: 'Fonction',
          organization: 'Organisation',
          quote: 'Citation du témoignage...',
          avatar: null
        }
      ]
    },
    // Features Section - Ancien style avec images restauré
    features: {
      sectionLabel: '01 — Fonctionnalités',
      sectionTitle: 'Pourquoi VF Actions ?',
      sectionSubtitle: 'Une solution complète pour accompagner votre transformation numérique',
      // Feature 1: IA Marketing (avec image)
      aiTitle: 'IA Spécialisée Marketing',
      aiDesc: 'Algorithmes optimisés pour créer du contenu percutant. Chaque texte est pensé pour engager votre audience.',
      aiFeature1: 'Optimisation SEO automatique',
      aiFeature2: 'Ton adapté à votre marque',
      aiFeature3: 'Structure optimisée',
      // Feature 2: Engagement (avec image)
      ecoTitle: 'Engagement Responsable',
      ecoDesc: 'Une approche responsable de l\'IA, au service de l\'humain et des territoires.',
      ecoFeature1: 'Accompagnement humain dédié',
      ecoFeature2: 'Impact positif mesurable',
      ecoFeature3: 'Proximité et transparence',
      // Legacy features (gardés pour compatibilité)
      humanTitle: 'Accompagnement humain',
      humanDesc: 'L\'IA ne remplace pas l\'humain. Elle lui permet d\'agir plus efficacement.',
      humanFeature1: 'Expert dédié à votre projet',
      humanFeature2: 'Support personnalisé',
      humanFeature3: 'Formation et prise en main',
      resultsTitle: 'Résultats concrets',
      resultsDesc: 'Pas de promesses technologiques. Des livrables actionnables immédiatement.',
      resultsFeature1: 'Stratégie marketing complète',
      resultsFeature2: 'Contenus prêts à l\'emploi',
      resultsFeature3: 'Impact mesurable',
      simplicityTitle: 'Simplicité d\'adoption',
      simplicityDesc: 'Pas besoin d\'être expert en IA. Notre approche progressive s\'adapte à votre rythme.',
      simplicityFeature1: 'Interface intuitive',
      simplicityFeature2: 'Pas de jargon technique',
      simplicityFeature3: 'Accompagnement pas à pas',
      proximityTitle: 'Proximité territoriale',
      proximityDesc: 'Nous connaissons les réalités des territoires.',
      proximityFeature1: 'Connaissance du terrain',
      proximityFeature2: 'Solutions adaptées',
      proximityFeature3: 'Ancrage local',
    },
    // Stats Section - Ancien style restauré
    stats: {
      contentTypes: 'Types de contenu',
      contentTypesDesc: 'Blog, Social, Email...',
      madeInFrance: 'Made in France',
      madeInFranceDesc: 'Conception française',
      aiGeneration: 'Dernière génération',
      aiGenerationDesc: 'IA optimisée',
      support: 'Support garanti',
      supportDesc: 'Équipe française',
      // Legacy (gardés pour compatibilité)
      territories: 'Territoires',
      territoriesDesc: 'Collectivités accompagnées',
      organizations: 'Organisations',
      organizationsDesc: 'PME et associations',
      satisfaction: 'Satisfaction',
      satisfactionDesc: 'De nos utilisateurs',
    },
    // Values Section - Nouveau
    values: {
      sectionLabel: '02 — Nos valeurs',
      sectionTitle: 'Ce qui nous différencie',
      sectionSubtitle: 'VF ACTIONS n\'est pas un énième outil IA. C\'est votre partenaire de confiance.',
      value1Title: 'Proximité',
      value1Desc: 'Nous sommes sur le terrain, pas dans une tour d\'ivoire technologique.',
      value2Title: 'Innovation utile',
      value2Desc: 'L\'IA au service de vos objectifs, pas l\'inverse.',
      value3Title: 'Transparence',
      value3Desc: 'Pas de promesses irréalistes. Des résultats vérifiables.',
      value4Title: 'Accompagnement',
      value4Desc: 'Un partenaire humain à chaque étape de votre transformation.',
    },
    // Target audiences - Nouveau
    audiences: {
      sectionLabel: '03 — Pour qui ?',
      sectionTitle: 'Nous accompagnons les acteurs du terrain',
      sectionSubtitle: 'Collectivités, associations, PME : l\'IA accessible à tous.',
      collectivities: 'Collectivités',
      collectivitiesDesc: 'Mairies, intercommunalités, départements, régions : modernisez votre communication.',
      associations: 'Associations',
      associationsDesc: 'ONG, structures ESS, associations locales : amplifiez votre impact avec des moyens limités.',
      pme: 'PME',
      pmeDesc: 'Artisans, commerçants, prestataires : développez votre visibilité sans complexité.',
      projects: 'Porteurs de projets',
      projectsDesc: 'Startups, entrepreneurs, initiatives citoyennes : lancez-vous avec les bons outils.',
    },
    // Transparency Section - Ancien style restauré
    transparency: {
      sectionTitle: 'Transparence',
      title: 'Notre engagement',
      subtitle: 'Pas de faux témoignages. Que des faits.',
      realData: 'Données réelles',
      realDataDesc: 'Aucune statistique inventée',
      rgpd: 'Conforme',
      rgpdDesc: 'Vos données protégées',
      verified: 'Vérifié',
      verifiedDesc: 'Impact positif',
      verifiedPartner: 'Partenariat certifié',
      message: 'VF Actions accompagne la transformation numérique des territoires avec',
      transparency: 'transparence',
      and: 'et',
      authenticity: 'authenticité',
      testimonialNote: 'Les témoignages seront ajoutés au fur et à mesure des retours réels de nos utilisateurs.',
      ctaButton: 'Rejoindre les premiers utilisateurs',
      ctaSubtext: 'Sans engagement • Contribuez à notre évolution',
    },
  },

  en: {
    nav: {
      dashboard: 'Dashboard',
      actualites: 'News',
      pricing: 'Pricing',
      admin: 'Admin',
      login: 'Login',
      register: 'Sign Up',
      logout: 'Logout',
    },
    hero: {
      badge: 'VF ACTIONS - AI for Territories',
      title1: 'AI at the Service',
      title2: 'of Territories',
      subtitle: 'We support local authorities, SMEs and associations in adopting artificial intelligence.',
      subtitleAccent: 'Simple. Human. Concrete.',
      cta: 'Discover our approach',
      ctaLogin: 'Go to Dashboard',
      // Titre principal - Slogan territorial
      heroTitle1: 'AI at the Service',
      heroTitle2: 'of Territories',
      // Message secondaire - Bénéfice client clair
      heroSubtitle: 'Save time, optimize your resources and focus on what matters most.',
      heroSubtitleAccent: 'Simple. Fast. Efficient.',
      ctaStart: 'Create my strategy',
      ctaDiscover: 'Discover',
      // Stats restaurées
      statCreations: 'creations',
      statTrees: 'trees planted',
      statSatisfied: 'satisfied',
      // Badge territorial discret
      aiService: 'AI at the service of territories',
      // Differentiators (gardés pour compatibilité)
      diffHuman: 'Human Support',
      diffResults: 'Measurable Results',
      diffSimple: 'Simple Adoption',
      // CTAs avec emojis restaurés
      ctaCreateStrategy: '✨ Create my marketing strategy',
      ctaDashboard: '🚀 Go to PRO Dashboard',
      ctaNewStrategy: '✨ New strategy',
      ctaMyProjects: 'My Projects',
      ctaHaveAccount: 'I already have an account',
      ctaSubtext: 'Free • No commitment • Results in minutes',
      // Audience chips (gardés pour compatibilité)
      chipCollectivities: 'Local Authorities',
      chipAssociations: 'Associations',
      chipPME: 'SMEs',
      chipProjects: 'Project Leaders',
      statTerritories: 'territories supported',
      statOrganizations: 'organizations',
      statSatisfaction: 'satisfaction',
    },
    auth: {
      loginTitle: 'Login',
      registerTitle: 'Create Account',
      email: 'Email',
      password: 'Password',
      name: 'Full Name',
      forgotPassword: 'Forgot password?',
      loginBtn: 'Login',
      registerBtn: 'Sign Up',
      switchToRegister: 'Create account',
      switchToLogin: 'Login',
      orContinueWith: 'Or continue with',
      googleLogin: 'Google',
      passwordRequirements: '8+ characters, uppercase, lowercase, digit',
      loginSuccess: 'Login successful!',
      registerSuccess: 'Account created! Check your email.',
      loginError: 'Login error',
      registerError: 'Registration error',
    },
    dashboard: {
      welcome: 'Welcome',
      credits: 'Credits',
      plan: 'Plan',
      generate: 'Generate Content',
      history: 'History',
      templates: 'Templates',
      contentType: 'Content Type',
      topic: 'Topic',
      tone: 'Tone',
      wordCount: 'Word Count',
      industry: 'Industry',
      instructions: 'Additional Instructions',
      generateBtn: 'Generate',
      generating: 'Generating...',
      result: 'Result',
      copy: 'Copy',
      save: 'Save',
      noCredits: 'No credits available',
    },
    contentTypes: {
      blog: 'Blog Post',
      social: 'Social Media Post',
      email: 'Marketing Email',
      ad: 'Advertisement',
      description: 'Product Description',
    },
    tones: {
      professional: 'Professional',
      casual: 'Casual',
      formal: 'Formal',
      friendly: 'Friendly',
      persuasive: 'Persuasive',
    },
    pricing: {
      title: 'Simple and Transparent Pricing',
      subtitle: 'Choose the plan that suits you',
      free: 'Discovery',
      starter: 'Starter',
      pro: 'Pro',
      enterprise: 'Enterprise',
      perMonth: '/month',
      credits: 'credits',
      features: 'Features',
      choosePlan: 'Choose',
      currentPlan: 'Current Plan',
      popular: 'Popular',
    },
    news: {
      title: 'News Center',
      newFeatures: 'New Features',
      tips: 'Marketing Tips',
      rse: 'CSR & Ecology',
      share: 'Share',
      loading: 'Loading...',
    },
    admin: {
      title: 'Administration',
      stats: 'Statistics',
      users: 'Users',
      analytics: 'Analytics',
      totalUsers: 'Total Users',
      totalRevenue: 'Total Revenue',
      mrr: 'MRR',
      arr: 'ARR',
      churn: 'Churn Rate',
      ltv: 'LTV',
      arpu: 'ARPU',
      manageUser: 'Manage',
    },
    common: {
      loading: 'Loading...',
      error: 'Error',
      success: 'Success',
      cancel: 'Cancel',
      save: 'Save',
      delete: 'Delete',
      edit: 'Edit',
      close: 'Close',
      back: 'Back',
      next: 'Next',
      yes: 'Yes',
      no: 'No',
      or: 'or',
    },
    footer: {
      rights: 'All rights reserved',
      privacy: 'Privacy',
      terms: 'Terms',
      tagline: 'AI at the service of territories.',
      description: 'VF ACTIONS supports local authorities, associations and SMEs in adopting artificial intelligence, with a simple, human and results-oriented approach.',
      badges: '100% Made in France • Human support • GDPR',
      navTitle: 'Navigation',
      navHome: 'Home',
      navCreateStrategy: 'Create my strategy',
      navPricing: 'Pricing',
      navNews: 'News',
      legalTitle: 'Legal',
      legalMentions: 'Legal notices',
      legalCGU: 'Terms of service',
      legalPrivacy: 'Privacy policy',
      legalRGPD: 'GDPR',
      copyright: 'VF Actions — AI at the service of territories. All rights reserved.',
    },
    features: {
      sectionLabel: '01 — Features',
      sectionTitle: 'Why VF Actions?',
      sectionSubtitle: 'A complete solution to support your digital transformation',
      // Feature 1: IA Marketing (avec image)
      aiTitle: 'Marketing-Specialized AI',
      aiDesc: 'Optimized algorithms to create impactful content. Every text is designed to engage your audience.',
      aiFeature1: 'Automatic SEO optimization',
      aiFeature2: 'Tone adapted to your brand',
      aiFeature3: 'Optimized structure',
      // Feature 2: Engagement (avec image)
      ecoTitle: 'Responsible Commitment',
      ecoDesc: 'A responsible approach to AI, at the service of people and territories.',
      ecoFeature1: 'Dedicated human support',
      ecoFeature2: 'Measurable positive impact',
      ecoFeature3: 'Proximity and transparency',
      // Legacy features (gardés pour compatibilité)
      humanTitle: 'Human Support',
      humanDesc: 'AI doesn\'t replace humans. It helps them act more effectively.',
      humanFeature1: 'Dedicated expert for your project',
      humanFeature2: 'Personalized support',
      humanFeature3: 'Training and onboarding',
      resultsTitle: 'Concrete Results',
      resultsDesc: 'No tech promises. Immediately actionable deliverables.',
      resultsFeature1: 'Complete marketing strategy',
      resultsFeature2: 'Ready-to-use content',
      resultsFeature3: 'Measurable impact',
      simplicityTitle: 'Simple Adoption',
      simplicityDesc: 'No need to be an AI expert. Our progressive approach adapts to your pace.',
      simplicityFeature1: 'Intuitive interface',
      simplicityFeature2: 'No technical jargon',
      simplicityFeature3: 'Step-by-step support',
      proximityTitle: 'Territorial Proximity',
      proximityDesc: 'We know the realities of territories.',
      proximityFeature1: 'Field knowledge',
      proximityFeature2: 'Adapted solutions',
      proximityFeature3: 'Local roots',
    },
    stats: {
      contentTypes: 'Content Types',
      contentTypesDesc: 'Blog, Social, Email...',
      madeInFrance: 'Made in France',
      madeInFranceDesc: 'French design',
      aiGeneration: 'Latest Generation',
      aiGenerationDesc: 'Optimized AI',
      support: 'Guaranteed Support',
      supportDesc: 'French team',
      // Legacy (gardés pour compatibilité)
      territories: 'Territories',
      territoriesDesc: 'Supported authorities',
      organizations: 'Organizations',
      organizationsDesc: 'SMEs and associations',
      satisfaction: 'Satisfaction',
      satisfactionDesc: 'From our users',
    },
    // Values Section - New
    values: {
      sectionLabel: '02 — Our values',
      sectionTitle: 'What sets us apart',
      sectionSubtitle: 'VF ACTIONS isn\'t just another AI tool. It\'s your trusted partner.',
      value1Title: 'Proximity',
      value1Desc: 'We\'re on the ground, not in a tech ivory tower.',
      value2Title: 'Useful Innovation',
      value2Desc: 'AI serving your goals, not the other way around.',
      value3Title: 'Transparency',
      value3Desc: 'No unrealistic promises. Verifiable results.',
      value4Title: 'Support',
      value4Desc: 'A human partner at every step of your transformation.',
    },
    // Target audiences - New
    audiences: {
      sectionLabel: '03 — For whom?',
      sectionTitle: 'We support field actors',
      sectionSubtitle: 'Local authorities, associations, SMEs: AI accessible to all.',
      collectivities: 'Local Authorities',
      collectivitiesDesc: 'Municipalities, inter-municipalities, departments, regions: modernize your communication.',
      associations: 'Associations',
      associationsDesc: 'NGOs, social economy structures, local associations: amplify your impact with limited resources.',
      pme: 'SMEs',
      pmeDesc: 'Craftsmen, merchants, service providers: develop your visibility without complexity.',
      projects: 'Project Leaders',
      projectsDesc: 'Startups, entrepreneurs, citizen initiatives: get started with the right tools.',
    },
    transparency: {
      sectionTitle: 'Transparency',
      title: 'Our commitment',
      subtitle: 'No fake testimonials. Just facts.',
      realData: 'Real Data',
      realDataDesc: 'No made-up statistics',
      rgpd: 'Compliant',
      rgpdDesc: 'Your data protected',
      verified: 'Verified',
      verifiedDesc: 'Positive impact',
      verifiedPartner: 'Certified partnership',
      message: 'VF Actions supports the digital transformation of territories with',
      transparency: 'transparency',
      and: 'and',
      authenticity: 'authenticity',
      testimonialNote: 'Testimonials will be added as we receive real feedback from our users.',
      ctaButton: 'Join the early adopters',
      ctaSubtext: 'No commitment • Contribute to our evolution',
    },
  },

  es: {
    nav: {
      dashboard: 'Panel',
      actualites: 'Noticias',
      pricing: 'Precios',
      admin: 'Admin',
      login: 'Iniciar sesión',
      register: 'Registrarse',
      logout: 'Cerrar sesión',
    },
    hero: {
      badge: 'VF ACTIONS - Solución de Marketing con IA',
      title1: 'Automatiza Tu Creación de Contenido',
      title2: 'con IA',
      subtitle: 'Genera contenido de marketing profesional en segundos. Blog, redes sociales, emails - todo es posible con VF ACTIONS.',
      cta: 'Comenzar ahora',
      ctaLogin: 'Ir al Panel',
      heroTitle1: 'Tus ideas,',
      heroTitle2: 'amplificadas',
      heroSubtitle: 'Transforma tus pensamientos en contenidos profesionales.',
      heroSubtitleAccent: 'Simple. Rápido. Responsable.',
      ctaStart: 'Comenzar',
      ctaDiscover: 'Descubrir',
      statCreations: 'creaciones',
      statTrees: 'árboles plantados',
      statSatisfied: 'satisfechos',
      aiService: 'La IA al servicio de tu marketing',
    },
    auth: {
      loginTitle: 'Iniciar sesión',
      registerTitle: 'Crear cuenta',
      email: 'Email',
      password: 'Contraseña',
      name: 'Nombre completo',
      forgotPassword: '¿Olvidaste tu contraseña?',
      loginBtn: 'Iniciar sesión',
      registerBtn: 'Registrarse',
      switchToRegister: 'Crear cuenta',
      switchToLogin: 'Iniciar sesión',
      orContinueWith: 'O continuar con',
      googleLogin: 'Google',
      passwordRequirements: '8+ caracteres, mayúscula, minúscula, dígito',
      loginSuccess: '¡Inicio de sesión exitoso!',
      registerSuccess: '¡Cuenta creada! Revisa tu email.',
      loginError: 'Error de inicio de sesión',
      registerError: 'Error de registro',
    },
    dashboard: {
      welcome: 'Bienvenido',
      credits: 'Créditos',
      plan: 'Plan',
      generate: 'Generar Contenido',
      history: 'Historial',
      templates: 'Plantillas',
      contentType: 'Tipo de contenido',
      topic: 'Tema',
      tone: 'Tono',
      wordCount: 'Número de palabras',
      industry: 'Industria',
      instructions: 'Instrucciones adicionales',
      generateBtn: 'Generar',
      generating: 'Generando...',
      result: 'Resultado',
      copy: 'Copiar',
      save: 'Guardar',
      noCredits: 'Sin créditos disponibles',
    },
    contentTypes: {
      blog: 'Artículo de Blog',
      social: 'Post Redes Sociales',
      email: 'Email Marketing',
      ad: 'Publicidad',
      description: 'Descripción de Producto',
    },
    tones: {
      professional: 'Profesional',
      casual: 'Casual',
      formal: 'Formal',
      friendly: 'Amigable',
      persuasive: 'Persuasivo',
    },
    pricing: {
      title: 'Precios Simples y Transparentes',
      subtitle: 'Elige el plan que te conviene',
      free: 'Descubrimiento',
      starter: 'Starter',
      pro: 'Pro',
      enterprise: 'Empresa',
      perMonth: '/mes',
      credits: 'créditos',
      features: 'Características',
      choosePlan: 'Elegir',
      currentPlan: 'Plan actual',
      popular: 'Popular',
    },
    news: {
      title: 'Centro de Noticias',
      newFeatures: 'Novedades',
      tips: 'Consejos de Marketing',
      rse: 'RSE & Ecología',
      share: 'Compartir',
      loading: 'Cargando...',
    },
    admin: {
      title: 'Administración',
      stats: 'Estadísticas',
      users: 'Usuarios',
      analytics: 'Analytics',
      totalUsers: 'Usuarios totales',
      totalRevenue: 'Ingresos totales',
      mrr: 'MRR',
      arr: 'ARR',
      churn: 'Tasa de churn',
      ltv: 'LTV',
      arpu: 'ARPU',
      manageUser: 'Gestionar',
    },
    common: {
      loading: 'Cargando...',
      error: 'Error',
      success: 'Éxito',
      cancel: 'Cancelar',
      save: 'Guardar',
      delete: 'Eliminar',
      edit: 'Editar',
      close: 'Cerrar',
      back: 'Atrás',
      next: 'Siguiente',
      yes: 'Sí',
      no: 'No',
      or: 'o',
    },
    footer: {
      rights: 'Todos los derechos reservados',
      privacy: 'Privacidad',
      terms: 'Términos',
    },
    features: {
      aiTitle: 'IA Especializada en Marketing',
      aiDesc: 'Algoritmos optimizados para crear contenido impactante. Cada texto está pensado para captar a tu audiencia.',
      aiFeature1: 'Optimización SEO automática',
      aiFeature2: 'Tono adaptado a tu marca',
      aiFeature3: 'Estructura H1-H3 optimizada',
      ecoTitle: 'Compromiso Ecológico',
      ecoDesc: 'Cada contenido generado contribuye a nuestro impacto positivo. Plantamos árboles y compensamos nuestra huella de carbono.',
      ecoFeature1: '1 árbol plantado / 100 contenidos',
      ecoFeature2: 'Servidores eco-responsables',
      ecoFeature3: 'Balance de carbono transparente',
    },
    stats: {
      contentTypes: 'Tipos de contenido',
      contentTypesDesc: 'Blog, Social, Email...',
      madeInFrance: 'Made in France',
      madeInFranceDesc: 'Diseño francés',
      aiGeneration: 'Última generación',
      aiGenerationDesc: 'GPT-4 optimizado',
      support: 'Soporte garantizado',
      supportDesc: 'Equipo francés',
    },
    transparency: {
      sectionTitle: 'Transparencia',
      title: 'Nuestro compromiso',
      subtitle: 'Sin testimonios falsos. Solo hechos.',
      realData: 'Datos reales',
      realDataDesc: 'Sin estadísticas inventadas',
      rgpd: 'Conforme',
      rgpdDesc: 'Tus datos protegidos',
      verified: 'Verificado',
      verifiedDesc: 'Impacto ecológico',
      verifiedPartner: 'Asociación certificada',
      message: 'VF Actions es un proyecto en desarrollo. Construimos nuestra comunidad con',
      transparency: 'transparencia',
      and: 'y',
      authenticity: 'autenticidad',
      testimonialNote: 'Los testimonios se añadirán a medida que recibamos comentarios reales de nuestros usuarios.',
      ctaButton: 'Únete a los primeros usuarios',
      ctaSubtext: 'Sin compromiso • Contribuye a nuestra evolución',
    },
  },

  de: {
    nav: {
      dashboard: 'Dashboard',
      actualites: 'Neuigkeiten',
      pricing: 'Preise',
      admin: 'Admin',
      login: 'Anmelden',
      register: 'Registrieren',
      logout: 'Abmelden',
    },
    hero: {
      badge: 'VF ACTIONS - KI-Marketing-Lösung',
      title1: 'Automatisieren Sie Ihre Content-Erstellung',
      title2: 'mit KI',
      subtitle: 'Erstellen Sie professionelle Marketing-Inhalte in Sekunden. Blog, Social Media, E-Mails - alles ist möglich mit VF ACTIONS.',
      cta: 'Jetzt starten',
      ctaLogin: 'Zum Dashboard',
      heroTitle1: 'Ihre Ideen,',
      heroTitle2: 'verstärkt',
      heroSubtitle: 'Verwandeln Sie Ihre Gedanken in professionelle Inhalte.',
      heroSubtitleAccent: 'Einfach. Schnell. Verantwortungsvoll.',
      ctaStart: 'Starten',
      ctaDiscover: 'Entdecken',
      statCreations: 'Kreationen',
      statTrees: 'Bäume gepflanzt',
      statSatisfied: 'zufrieden',
      aiService: 'KI im Dienste Ihres Marketings',
    },
    auth: {
      loginTitle: 'Anmelden',
      registerTitle: 'Konto erstellen',
      email: 'E-Mail',
      password: 'Passwort',
      name: 'Vollständiger Name',
      forgotPassword: 'Passwort vergessen?',
      loginBtn: 'Anmelden',
      registerBtn: 'Registrieren',
      switchToRegister: 'Konto erstellen',
      switchToLogin: 'Anmelden',
      orContinueWith: 'Oder fortfahren mit',
      googleLogin: 'Google',
      passwordRequirements: '8+ Zeichen, Großbuchstabe, Kleinbuchstabe, Zahl',
      loginSuccess: 'Anmeldung erfolgreich!',
      registerSuccess: 'Konto erstellt! Überprüfen Sie Ihre E-Mail.',
      loginError: 'Anmeldefehler',
      registerError: 'Registrierungsfehler',
    },
    dashboard: {
      welcome: 'Willkommen',
      credits: 'Guthaben',
      plan: 'Plan',
      generate: 'Inhalt generieren',
      history: 'Verlauf',
      templates: 'Vorlagen',
      contentType: 'Inhaltstyp',
      topic: 'Thema',
      tone: 'Ton',
      wordCount: 'Wortanzahl',
      industry: 'Branche',
      instructions: 'Zusätzliche Anweisungen',
      generateBtn: 'Generieren',
      generating: 'Wird generiert...',
      result: 'Ergebnis',
      copy: 'Kopieren',
      save: 'Speichern',
      noCredits: 'Kein Guthaben verfügbar',
    },
    contentTypes: {
      blog: 'Blog-Artikel',
      social: 'Social-Media-Post',
      email: 'Marketing-E-Mail',
      ad: 'Werbung',
      description: 'Produktbeschreibung',
    },
    tones: {
      professional: 'Professionell',
      casual: 'Locker',
      formal: 'Formell',
      friendly: 'Freundlich',
      persuasive: 'Überzeugend',
    },
    pricing: {
      title: 'Einfache und transparente Preise',
      subtitle: 'Wählen Sie den passenden Plan',
      free: 'Entdeckung',
      starter: 'Starter',
      pro: 'Pro',
      enterprise: 'Unternehmen',
      perMonth: '/Monat',
      credits: 'Guthaben',
      features: 'Funktionen',
      choosePlan: 'Wählen',
      currentPlan: 'Aktueller Plan',
      popular: 'Beliebt',
    },
    news: {
      title: 'Neuigkeiten-Center',
      newFeatures: 'Neue Funktionen',
      tips: 'Marketing-Tipps',
      rse: 'CSR & Ökologie',
      share: 'Teilen',
      loading: 'Wird geladen...',
    },
    admin: {
      title: 'Administration',
      stats: 'Statistiken',
      users: 'Benutzer',
      analytics: 'Analytics',
      totalUsers: 'Gesamtbenutzer',
      totalRevenue: 'Gesamtumsatz',
      mrr: 'MRR',
      arr: 'ARR',
      churn: 'Abwanderungsrate',
      ltv: 'LTV',
      arpu: 'ARPU',
      manageUser: 'Verwalten',
    },
    common: {
      loading: 'Wird geladen...',
      error: 'Fehler',
      success: 'Erfolg',
      cancel: 'Abbrechen',
      save: 'Speichern',
      delete: 'Löschen',
      edit: 'Bearbeiten',
      close: 'Schließen',
      back: 'Zurück',
      next: 'Weiter',
      yes: 'Ja',
      no: 'Nein',
      or: 'oder',
    },
    footer: {
      rights: 'Alle Rechte vorbehalten',
      privacy: 'Datenschutz',
      terms: 'AGB',
    },
    features: {
      aiTitle: 'Marketing-spezialisierte KI',
      aiDesc: 'Optimierte Algorithmen für wirkungsvolle Inhalte. Jeder Text ist darauf ausgelegt, Ihr Publikum zu engagieren.',
      aiFeature1: 'Automatische SEO-Optimierung',
      aiFeature2: 'Ton an Ihre Marke angepasst',
      aiFeature3: 'Optimierte H1-H3-Struktur',
      ecoTitle: 'Ökologisches Engagement',
      ecoDesc: 'Jeder generierte Inhalt trägt zu unserem positiven Impact bei. Wir pflanzen Bäume und kompensieren unseren CO2-Fußabdruck.',
      ecoFeature1: '1 Baum gepflanzt / 100 Inhalte',
      ecoFeature2: 'Umweltfreundliche Server',
      ecoFeature3: 'Transparente CO2-Bilanz',
    },
    stats: {
      contentTypes: 'Inhaltstypen',
      contentTypesDesc: 'Blog, Social, E-Mail...',
      madeInFrance: 'Made in France',
      madeInFranceDesc: 'Französisches Design',
      aiGeneration: 'Neueste Generation',
      aiGenerationDesc: 'Optimiertes GPT-4',
      support: 'Garantierter Support',
      supportDesc: 'Französisches Team',
    },
    transparency: {
      sectionTitle: 'Transparenz',
      title: 'Unser Engagement',
      subtitle: 'Keine falschen Testimonials. Nur Fakten.',
      realData: 'Echte Daten',
      realDataDesc: 'Keine erfundenen Statistiken',
      rgpd: 'Konform',
      rgpdDesc: 'Ihre Daten geschützt',
      verified: 'Verifiziert',
      verifiedDesc: 'Ökologischer Impact',
      verifiedPartner: 'Zertifizierte Partnerschaft',
      message: 'VF Actions ist ein Projekt in Entwicklung. Wir bauen unsere Community mit',
      transparency: 'Transparenz',
      and: 'und',
      authenticity: 'Authentizität',
      testimonialNote: 'Testimonials werden hinzugefügt, sobald wir echtes Feedback von unseren Nutzern erhalten.',
      ctaButton: 'Werden Sie Early Adopter',
      ctaSubtext: 'Unverbindlich • Tragen Sie zu unserer Entwicklung bei',
    },
  },

  it: {
    nav: {
      dashboard: 'Dashboard',
      actualites: 'Novità',
      pricing: 'Prezzi',
      admin: 'Admin',
      login: 'Accedi',
      register: 'Registrati',
      logout: 'Esci',
    },
    hero: {
      badge: 'VF ACTIONS - Soluzione Marketing IA',
      title1: 'Automatizza la Creazione dei Tuoi Contenuti',
      title2: 'con l\'IA',
      subtitle: 'Genera contenuti marketing professionali in pochi secondi. Blog, social media, email - tutto è possibile con VF ACTIONS.',
      cta: 'Inizia ora',
      ctaLogin: 'Vai alla Dashboard',
      heroTitle1: 'Le tue idee,',
      heroTitle2: 'amplificate',
      heroSubtitle: 'Trasforma i tuoi pensieri in contenuti professionali.',
      heroSubtitleAccent: 'Semplice. Veloce. Responsabile.',
      ctaStart: 'Inizia',
      ctaDiscover: 'Scopri',
      statCreations: 'creazioni',
      statTrees: 'alberi piantati',
      statSatisfied: 'soddisfatti',
      aiService: "L'IA al servizio del tuo marketing",
    },
    auth: {
      loginTitle: 'Accedi',
      registerTitle: 'Crea account',
      email: 'Email',
      password: 'Password',
      name: 'Nome completo',
      forgotPassword: 'Password dimenticata?',
      loginBtn: 'Accedi',
      registerBtn: 'Registrati',
      switchToRegister: 'Crea account',
      switchToLogin: 'Accedi',
      orContinueWith: 'Oppure continua con',
      googleLogin: 'Google',
      passwordRequirements: '8+ caratteri, maiuscola, minuscola, cifra',
      loginSuccess: 'Accesso riuscito!',
      registerSuccess: 'Account creato! Controlla la tua email.',
      loginError: 'Errore di accesso',
      registerError: 'Errore di registrazione',
    },
    dashboard: {
      welcome: 'Benvenuto',
      credits: 'Crediti',
      plan: 'Piano',
      generate: 'Genera Contenuto',
      history: 'Cronologia',
      templates: 'Modelli',
      contentType: 'Tipo di contenuto',
      topic: 'Argomento',
      tone: 'Tono',
      wordCount: 'Numero di parole',
      industry: 'Settore',
      instructions: 'Istruzioni aggiuntive',
      generateBtn: 'Genera',
      generating: 'Generazione...',
      result: 'Risultato',
      copy: 'Copia',
      save: 'Salva',
      noCredits: 'Crediti non disponibili',
    },
    contentTypes: {
      blog: 'Articolo Blog',
      social: 'Post Social Media',
      email: 'Email Marketing',
      ad: 'Pubblicità',
      description: 'Descrizione Prodotto',
    },
    tones: {
      professional: 'Professionale',
      casual: 'Casual',
      formal: 'Formale',
      friendly: 'Amichevole',
      persuasive: 'Persuasivo',
    },
    pricing: {
      title: 'Prezzi Semplici e Trasparenti',
      subtitle: 'Scegli il piano adatto a te',
      free: 'Scoperta',
      starter: 'Starter',
      pro: 'Pro',
      enterprise: 'Enterprise',
      perMonth: '/mese',
      credits: 'crediti',
      features: 'Funzionalità',
      choosePlan: 'Scegli',
      currentPlan: 'Piano attuale',
      popular: 'Popolare',
    },
    news: {
      title: 'Centro Novità',
      newFeatures: 'Nuove Funzioni',
      tips: 'Consigli Marketing',
      rse: 'RSI & Ecologia',
      share: 'Condividi',
      loading: 'Caricamento...',
    },
    admin: {
      title: 'Amministrazione',
      stats: 'Statistiche',
      users: 'Utenti',
      analytics: 'Analytics',
      totalUsers: 'Utenti totali',
      totalRevenue: 'Ricavi totali',
      mrr: 'MRR',
      arr: 'ARR',
      churn: 'Tasso di abbandono',
      ltv: 'LTV',
      arpu: 'ARPU',
      manageUser: 'Gestisci',
    },
    common: {
      loading: 'Caricamento...',
      error: 'Errore',
      success: 'Successo',
      cancel: 'Annulla',
      save: 'Salva',
      delete: 'Elimina',
      edit: 'Modifica',
      close: 'Chiudi',
      back: 'Indietro',
      next: 'Avanti',
      yes: 'Sì',
      no: 'No',
      or: 'o',
    },
    footer: {
      rights: 'Tutti i diritti riservati',
      privacy: 'Privacy',
      terms: 'Termini',
    },
    features: {
      aiTitle: 'IA Specializzata nel Marketing',
      aiDesc: 'Algoritmi ottimizzati per creare contenuti di impatto. Ogni testo è pensato per coinvolgere il tuo pubblico.',
      aiFeature1: 'Ottimizzazione SEO automatica',
      aiFeature2: 'Tono adattato al tuo brand',
      aiFeature3: 'Struttura H1-H3 ottimizzata',
      ecoTitle: 'Impegno Ecologico',
      ecoDesc: 'Ogni contenuto generato contribuisce al nostro impatto positivo. Piantiamo alberi e compensiamo la nostra impronta di carbonio.',
      ecoFeature1: '1 albero piantato / 100 contenuti',
      ecoFeature2: 'Server eco-responsabili',
      ecoFeature3: 'Bilancio carbonio trasparente',
    },
    stats: {
      contentTypes: 'Tipi di contenuto',
      contentTypesDesc: 'Blog, Social, Email...',
      madeInFrance: 'Made in France',
      madeInFranceDesc: 'Design francese',
      aiGeneration: 'Ultima generazione',
      aiGenerationDesc: 'GPT-4 ottimizzato',
      support: 'Supporto garantito',
      supportDesc: 'Team francese',
    },
    transparency: {
      sectionTitle: 'Trasparenza',
      title: 'Il nostro impegno',
      subtitle: 'Nessuna testimonianza falsa. Solo fatti.',
      realData: 'Dati reali',
      realDataDesc: 'Nessuna statistica inventata',
      rgpd: 'Conforme',
      rgpdDesc: 'I tuoi dati protetti',
      verified: 'Verificato',
      verifiedDesc: 'Impatto ecologico',
      verifiedPartner: 'Partnership certificata',
      message: 'VF Actions è un progetto in sviluppo. Costruiamo la nostra comunità con',
      transparency: 'trasparenza',
      and: 'e',
      authenticity: 'autenticità',
      testimonialNote: 'Le testimonianze saranno aggiunte man mano che riceviamo feedback reali dai nostri utenti.',
      ctaButton: 'Unisciti ai primi utenti',
      ctaSubtext: 'Senza impegno • Contribuisci alla nostra evoluzione',
    },
  },

  pt: {
    nav: {
      dashboard: 'Painel',
      actualites: 'Notícias',
      pricing: 'Preços',
      admin: 'Admin',
      login: 'Entrar',
      register: 'Registrar',
      logout: 'Sair',
    },
    hero: {
      badge: 'VF ACTIONS - Solução de Marketing com IA',
      title1: 'Automatize Sua Criação de Conteúdo',
      title2: 'com IA',
      subtitle: 'Gere conteúdo de marketing profissional em segundos. Blog, redes sociais, emails - tudo é possível com VF ACTIONS.',
      cta: 'Começar agora',
      ctaLogin: 'Ir para o Painel',
    },
    auth: {
      loginTitle: 'Entrar',
      registerTitle: 'Criar conta',
      email: 'Email',
      password: 'Senha',
      name: 'Nome completo',
      forgotPassword: 'Esqueceu a senha?',
      loginBtn: 'Entrar',
      registerBtn: 'Registrar',
      switchToRegister: 'Criar conta',
      switchToLogin: 'Entrar',
      orContinueWith: 'Ou continuar com',
      googleLogin: 'Google',
      passwordRequirements: '8+ caracteres, maiúscula, minúscula, número',
      loginSuccess: 'Login bem-sucedido!',
      registerSuccess: 'Conta criada! Verifique seu email.',
      loginError: 'Erro de login',
      registerError: 'Erro de registro',
    },
    dashboard: {
      welcome: 'Bem-vindo',
      credits: 'Créditos',
      plan: 'Plano',
      generate: 'Gerar Conteúdo',
      history: 'Histórico',
      templates: 'Modelos',
      contentType: 'Tipo de conteúdo',
      topic: 'Tópico',
      tone: 'Tom',
      wordCount: 'Número de palavras',
      industry: 'Indústria',
      instructions: 'Instruções adicionais',
      generateBtn: 'Gerar',
      generating: 'Gerando...',
      result: 'Resultado',
      copy: 'Copiar',
      save: 'Salvar',
      noCredits: 'Sem créditos disponíveis',
    },
    contentTypes: {
      blog: 'Artigo de Blog',
      social: 'Post Redes Sociais',
      email: 'Email Marketing',
      ad: 'Publicidade',
      description: 'Descrição de Produto',
    },
    tones: {
      professional: 'Profissional',
      casual: 'Casual',
      formal: 'Formal',
      friendly: 'Amigável',
      persuasive: 'Persuasivo',
    },
    pricing: {
      title: 'Preços Simples e Transparentes',
      subtitle: 'Escolha o plano ideal para você',
      free: 'Descoberta',
      starter: 'Starter',
      pro: 'Pro',
      enterprise: 'Empresarial',
      perMonth: '/mês',
      credits: 'créditos',
      features: 'Recursos',
      choosePlan: 'Escolher',
      currentPlan: 'Plano atual',
      popular: 'Popular',
    },
    news: {
      title: 'Centro de Notícias',
      newFeatures: 'Novidades',
      tips: 'Dicas de Marketing',
      rse: 'RSE & Ecologia',
      share: 'Compartilhar',
      loading: 'Carregando...',
    },
    admin: {
      title: 'Administração',
      stats: 'Estatísticas',
      users: 'Usuários',
      analytics: 'Analytics',
      totalUsers: 'Total de usuários',
      totalRevenue: 'Receita total',
      mrr: 'MRR',
      arr: 'ARR',
      churn: 'Taxa de churn',
      ltv: 'LTV',
      arpu: 'ARPU',
      manageUser: 'Gerenciar',
    },
    common: {
      loading: 'Carregando...',
      error: 'Erro',
      success: 'Sucesso',
      cancel: 'Cancelar',
      save: 'Salvar',
      delete: 'Excluir',
      edit: 'Editar',
      close: 'Fechar',
      back: 'Voltar',
      next: 'Próximo',
      yes: 'Sim',
      no: 'Não',
      or: 'ou',
    },
    footer: {
      rights: 'Todos os direitos reservados',
      privacy: 'Privacidade',
      terms: 'Termos',
    },
    features: {
      aiTitle: 'IA Especializada em Marketing',
      aiDesc: 'Algoritmos otimizados para criar conteúdo impactante. Cada texto é pensado para engajar seu público.',
      aiFeature1: 'Otimização SEO automática',
      aiFeature2: 'Tom adaptado à sua marca',
      aiFeature3: 'Estrutura H1-H3 otimizada',
      ecoTitle: 'Compromisso Ecológico',
      ecoDesc: 'Cada conteúdo gerado contribui para nosso impacto positivo. Plantamos árvores e compensamos nossa pegada de carbono.',
      ecoFeature1: '1 árvore plantada / 100 conteúdos',
      ecoFeature2: 'Servidores eco-responsáveis',
      ecoFeature3: 'Balanço de carbono transparente',
    },
    stats: {
      contentTypes: 'Tipos de conteúdo',
      contentTypesDesc: 'Blog, Social, Email...',
      madeInFrance: 'Made in France',
      madeInFranceDesc: 'Design francês',
      aiGeneration: 'Última geração',
      aiGenerationDesc: 'GPT-4 otimizado',
      support: 'Suporte garantido',
      supportDesc: 'Equipe francesa',
    },
    transparency: {
      sectionTitle: 'Transparência',
      title: 'Nosso compromisso',
      subtitle: 'Sem depoimentos falsos. Apenas fatos.',
      realData: 'Dados reais',
      realDataDesc: 'Sem estatísticas inventadas',
      rgpd: 'Conforme',
      rgpdDesc: 'Seus dados protegidos',
      verified: 'Verificado',
      verifiedDesc: 'Impacto ecológico',
      verifiedPartner: 'Parceria certificada',
      message: 'VF Actions é um projeto em desenvolvimento. Construímos nossa comunidade com',
      transparency: 'transparência',
      and: 'e',
      authenticity: 'autenticidade',
      testimonialNote: 'Os depoimentos serão adicionados conforme recebemos feedback real de nossos usuários.',
      ctaButton: 'Junte-se aos primeiros usuários',
      ctaSubtext: 'Sem compromisso • Contribua para nossa evolução',
    },
  },

  nl: {
    nav: {
      dashboard: 'Dashboard',
      actualites: 'Nieuws',
      pricing: 'Prijzen',
      admin: 'Admin',
      login: 'Inloggen',
      register: 'Registreren',
      logout: 'Uitloggen',
    },
    hero: {
      badge: 'VF ACTIONS - AI Marketing Oplossing',
      title1: 'Automatiseer Uw Content Creatie',
      title2: 'met AI',
      subtitle: 'Genereer professionele marketing content in seconden. Blog, social media, emails - alles is mogelijk met VF ACTIONS.',
      cta: 'Nu Starten',
      ctaLogin: 'Naar Dashboard',
    },
    auth: {
      loginTitle: 'Inloggen',
      registerTitle: 'Account aanmaken',
      email: 'E-mail',
      password: 'Wachtwoord',
      name: 'Volledige naam',
      forgotPassword: 'Wachtwoord vergeten?',
      loginBtn: 'Inloggen',
      registerBtn: 'Registreren',
      switchToRegister: 'Account aanmaken',
      switchToLogin: 'Inloggen',
      orContinueWith: 'Of doorgaan met',
      googleLogin: 'Google',
      passwordRequirements: '8+ tekens, hoofdletter, kleine letter, cijfer',
      loginSuccess: 'Succesvol ingelogd!',
      registerSuccess: 'Account aangemaakt! Check je email.',
      loginError: 'Inlogfout',
      registerError: 'Registratiefout',
    },
    dashboard: {
      welcome: 'Welkom',
      credits: 'Credits',
      plan: 'Plan',
      generate: 'Content Genereren',
      history: 'Geschiedenis',
      templates: 'Sjablonen',
      contentType: 'Content type',
      topic: 'Onderwerp',
      tone: 'Toon',
      wordCount: 'Aantal woorden',
      industry: 'Industrie',
      instructions: 'Extra instructies',
      generateBtn: 'Genereren',
      generating: 'Genereren...',
      result: 'Resultaat',
      copy: 'Kopiëren',
      save: 'Opslaan',
      noCredits: 'Geen credits beschikbaar',
    },
    contentTypes: {
      blog: 'Blog Artikel',
      social: 'Social Media Post',
      email: 'Marketing Email',
      ad: 'Advertentie',
      description: 'Productomschrijving',
    },
    tones: {
      professional: 'Professioneel',
      casual: 'Casual',
      formal: 'Formeel',
      friendly: 'Vriendelijk',
      persuasive: 'Overtuigend',
    },
    pricing: {
      title: 'Eenvoudige en Transparante Prijzen',
      subtitle: 'Kies het plan dat bij u past',
      free: 'Ontdekking',
      starter: 'Starter',
      pro: 'Pro',
      enterprise: 'Zakelijk',
      perMonth: '/maand',
      credits: 'credits',
      features: 'Functies',
      choosePlan: 'Kiezen',
      currentPlan: 'Huidig plan',
      popular: 'Populair',
    },
    news: {
      title: 'Nieuwscentrum',
      newFeatures: 'Nieuwe Functies',
      tips: 'Marketing Tips',
      rse: 'MVO & Ecologie',
      share: 'Delen',
      loading: 'Laden...',
    },
    admin: {
      title: 'Administratie',
      stats: 'Statistieken',
      users: 'Gebruikers',
      analytics: 'Analytics',
      totalUsers: 'Totaal gebruikers',
      totalRevenue: 'Totale omzet',
      mrr: 'MRR',
      arr: 'ARR',
      churn: 'Churn rate',
      ltv: 'LTV',
      arpu: 'ARPU',
      manageUser: 'Beheren',
    },
    common: {
      loading: 'Laden...',
      error: 'Fout',
      success: 'Succes',
      cancel: 'Annuleren',
      save: 'Opslaan',
      delete: 'Verwijderen',
      edit: 'Bewerken',
      close: 'Sluiten',
      back: 'Terug',
      next: 'Volgende',
      yes: 'Ja',
      no: 'Nee',
      or: 'of',
    },
    footer: {
      rights: 'Alle rechten voorbehouden',
      privacy: 'Privacy',
      terms: 'Voorwaarden',
    },
    features: {
      aiTitle: 'Marketing-gespecialiseerde AI',
      aiDesc: 'Geoptimaliseerde algoritmes om impactvolle content te maken. Elke tekst is ontworpen om uw publiek te engageren.',
      aiFeature1: 'Automatische SEO-optimalisatie',
      aiFeature2: 'Toon aangepast aan uw merk',
      aiFeature3: 'Geoptimaliseerde H1-H3-structuur',
      ecoTitle: 'Ecologische Toewijding',
      ecoDesc: 'Elke gegenereerde content draagt bij aan onze positieve impact. We planten bomen en compenseren onze CO2-voetafdruk.',
      ecoFeature1: '1 boom geplant / 100 contents',
      ecoFeature2: 'Eco-verantwoorde servers',
      ecoFeature3: 'Transparante CO2-balans',
    },
    stats: {
      contentTypes: 'Contenttypes',
      contentTypesDesc: 'Blog, Social, Email...',
      madeInFrance: 'Made in France',
      madeInFranceDesc: 'Frans ontwerp',
      aiGeneration: 'Nieuwste generatie',
      aiGenerationDesc: 'Geoptimaliseerde GPT-4',
      support: 'Gegarandeerde ondersteuning',
      supportDesc: 'Frans team',
    },
    transparency: {
      sectionTitle: 'Transparantie',
      title: 'Onze toewijding',
      subtitle: 'Geen valse getuigenissen. Alleen feiten.',
      realData: 'Echte data',
      realDataDesc: 'Geen verzonnen statistieken',
      rgpd: 'Conform',
      rgpdDesc: 'Uw gegevens beschermd',
      verified: 'Geverifieerd',
      verifiedDesc: 'Ecologische impact',
      verifiedPartner: 'Gecertificeerd partnerschap',
      message: 'VF Actions is een project in ontwikkeling. We bouwen onze gemeenschap met',
      transparency: 'transparantie',
      and: 'en',
      authenticity: 'authenticiteit',
      testimonialNote: 'Getuigenissen worden toegevoegd naarmate we echte feedback van onze gebruikers ontvangen.',
      ctaButton: 'Word early adopter',
      ctaSubtext: 'Vrijblijvend • Draag bij aan onze ontwikkeling',
    },
  },

  br: {
    // Breton
    nav: {
      dashboard: 'Taolenn-stur',
      actualites: 'Nevezintiou',
      pricing: 'Prizioù',
      admin: 'Merour',
      login: 'Kennaskañ',
      register: 'En em enskrivañ',
      logout: 'Digennaskañ',
    },
    hero: {
      badge: 'VF ACTIONS - Doareoù Marchañs IA',
      title1: 'Embregel Ho Krouadur Danvez',
      title2: 'gant an IA',
      subtitle: 'Krouiñ danvez marchañs a-vicher e eilennoù. Blog, rouedadoù sokial, posteloù - pep tra a zo posupl gant VF ACTIONS.',
      cta: 'Kregiñ bremañ',
      ctaLogin: "Mont d'an Taolenn-stur",
    },
    auth: {
      loginTitle: 'Kennaskañ',
      registerTitle: 'Krouiñ ur gont',
      email: 'Postel',
      password: 'Ger-tremen',
      name: 'Anv klok',
      forgotPassword: 'Ankounac\'het ho ker-tremen?',
      loginBtn: 'Kennaskañ',
      registerBtn: 'En em enskrivañ',
      switchToRegister: 'Krouiñ ur gont',
      switchToLogin: 'Kennaskañ',
      orContinueWith: 'Pe kenderc\'hel gant',
      googleLogin: 'Google',
      passwordRequirements: '8+ arouezenn, pennlizherenn, lizherenn vihan, sifr',
      loginSuccess: 'Kennask mat!',
      registerSuccess: 'Kont krouet! Gwiriit ho postel.',
      loginError: 'Fazi kennask',
      registerError: 'Fazi enskrivadur',
    },
    dashboard: {
      welcome: 'Degemer mat',
      credits: 'Kredoù',
      plan: 'Plan',
      generate: 'Krouiñ Danvez',
      history: 'Istor',
      templates: 'Patromoù',
      contentType: 'Seurt danvez',
      topic: 'Danvez',
      tone: 'Ton',
      wordCount: 'Niver gerioù',
      industry: 'Industri',
      instructions: "Reolennoù ouzhpenn",
      generateBtn: 'Krouiñ',
      generating: 'O krouiñ...',
      result: "Disoc'h",
      copy: 'Eilañ',
      save: 'Enrollañ',
      noCredits: "N'eus ket a gredoù",
    },
    contentTypes: {
      blog: 'Pennad Blog',
      social: 'Kemennadenn Sokial',
      email: 'Postel Marchañs',
      ad: 'Bruderezh',
      description: 'Deskrivadur Produioù',
    },
    tones: {
      professional: 'A-vicher',
      casual: 'Simpl',
      formal: 'Furmek',
      friendly: 'Mignoniñ',
      persuasive: 'Hentus',
    },
    pricing: {
      title: 'Prizioù Simpl ha Splann',
      subtitle: "Dibabit ar plan a zere deoc'h",
      free: 'Dizoleiñ',
      starter: 'Kregiñ',
      pro: 'Pro',
      enterprise: 'Embregezh',
      perMonth: '/miz',
      credits: 'kredoù',
      features: 'Perzhioù',
      choosePlan: 'Dibab',
      currentPlan: 'Plan bremañ',
      popular: 'Brudet',
    },
    news: {
      title: 'Kreizenn Nevezintiou',
      newFeatures: 'Perzhioù Nevez',
      tips: 'Alioù Marchañs',
      rse: 'RSE & Ekologiezh',
      share: 'Rannañ',
      loading: 'O kargañ...',
    },
    admin: {
      title: 'Mererezh',
      stats: 'Stadegoù',
      users: 'Implijerien',
      analytics: 'Analizadur',
      totalUsers: 'Hollad implijerien',
      totalRevenue: 'Hollad arc\'hant',
      mrr: 'MRR',
      arr: 'ARR',
      churn: 'Feur dilezadur',
      ltv: 'LTV',
      arpu: 'ARPU',
      manageUser: 'Merañ',
    },
    common: {
      loading: 'O kargañ...',
      error: 'Fazi',
      success: "Berzh",
      cancel: 'Nullañ',
      save: 'Enrollañ',
      delete: 'Diverkañ',
      edit: 'Kemmañ',
      close: 'Serriñ',
      back: 'Distreiñ',
      next: "War-lerc'h",
      yes: 'Ya',
      no: 'Nann',
      or: 'pe',
    },
    footer: {
      rights: 'Pep gwir miret',
      privacy: 'Prevezded',
      terms: 'Termenoù',
    },
    features: {
      aiTitle: 'IA Spisializet evit ar Marchañs',
      aiDesc: "Algoritmoù gwellekaat evit krouiñ danvez a droas. Pep testenn zo soñjet evit stagañ ho purevezh.",
      aiFeature1: 'Gwellekaat SEO emgefreek',
      aiFeature2: "Ton diazezet war ho merk",
      aiFeature3: 'Framm H1-H3 gwellekaat',
      ecoTitle: 'Emgav Ekologel',
      ecoDesc: "Pep danvez krouet a gas d'hon impakt pozitivel. Plantomp gwez ha kompansañ hon roud karbon.",
      ecoFeature1: '1 gwez plantet / 100 danvez',
      ecoFeature2: 'Servijerioù eko-responsupl',
      ecoFeature3: 'Balañs karbon splann',
    },
    stats: {
      contentTypes: 'Doareoù danvez',
      contentTypesDesc: 'Blog, Social, Postel...',
      madeInFrance: 'Graet e Bro-C\'hall',
      madeInFranceDesc: 'Dibunañ gallek',
      aiGeneration: 'Rummad diwezhañ',
      aiGenerationDesc: 'GPT-4 gwellekaat',
      support: 'Skoazell gwarantet',
      supportDesc: 'Skipailh gallek',
    },
    transparency: {
      sectionTitle: 'Splannder',
      title: 'Hon emgav',
      subtitle: 'Testenioù gaou ebet. Fazennoù hepken.',
      realData: 'Roadennoù gwir',
      realDataDesc: 'Stadegoù krouet ebet',
      rgpd: 'Kenglotus',
      rgpdDesc: 'Ho roadennoù gwarezet',
      verified: 'Gwiriet',
      verifiedDesc: 'Impakt ekologel',
      verifiedPartner: 'Kevelerezh testenet',
      message: "VF Actions zo ur raktres o tiorren. Sevel a reomp hon gumuniezh gant",
      transparency: 'splannder',
      and: 'ha',
      authenticity: 'gwirionded',
      testimonialNote: "An testenioù a vo ouzhpennet hervez an disterskoù gwir a resomp digant hon implijerien.",
      ctaButton: "Deuet da vezañ unan eus ar re gentañ",
      ctaSubtext: 'Digoust • Hep emgav • Kemerit perzh en hon diorroadur',
    },
  },

  pl: {
    nav: {
      dashboard: 'Panel',
      actualites: 'Aktualności',
      pricing: 'Cennik',
      admin: 'Admin',
      login: 'Zaloguj się',
      register: 'Zarejestruj się',
      logout: 'Wyloguj',
    },
    hero: {
      badge: 'VF ACTIONS - Rozwiązanie Marketingowe AI',
      title1: 'Zautomatyzuj Tworzenie Treści',
      title2: 'z AI',
      subtitle: 'Generuj profesjonalne treści marketingowe w kilka sekund. Blog, social media, emaile - wszystko jest możliwe z VF ACTIONS.',
      cta: 'Zacznij teraz',
      ctaLogin: 'Przejdź do Panelu',
    },
    auth: {
      loginTitle: 'Logowanie',
      registerTitle: 'Utwórz konto',
      email: 'Email',
      password: 'Hasło',
      name: 'Pełne imię',
      forgotPassword: 'Zapomniałeś hasła?',
      loginBtn: 'Zaloguj się',
      registerBtn: 'Zarejestruj się',
      switchToRegister: 'Utwórz konto',
      switchToLogin: 'Zaloguj się',
      orContinueWith: 'Lub kontynuuj przez',
      googleLogin: 'Google',
      passwordRequirements: '8+ znaków, wielka litera, mała litera, cyfra',
      loginSuccess: 'Logowanie udane!',
      registerSuccess: 'Konto utworzone! Sprawdź email.',
      loginError: 'Błąd logowania',
      registerError: 'Błąd rejestracji',
    },
    dashboard: {
      welcome: 'Witaj',
      credits: 'Kredyty',
      plan: 'Plan',
      generate: 'Generuj Treść',
      history: 'Historia',
      templates: 'Szablony',
      contentType: 'Typ treści',
      topic: 'Temat',
      tone: 'Ton',
      wordCount: 'Liczba słów',
      industry: 'Branża',
      instructions: 'Dodatkowe instrukcje',
      generateBtn: 'Generuj',
      generating: 'Generowanie...',
      result: 'Wynik',
      copy: 'Kopiuj',
      save: 'Zapisz',
      noCredits: 'Brak kredytów',
    },
    contentTypes: {
      blog: 'Artykuł Blogowy',
      social: 'Post Social Media',
      email: 'Email Marketingowy',
      ad: 'Reklama',
      description: 'Opis Produktu',
    },
    tones: {
      professional: 'Profesjonalny',
      casual: 'Casualowy',
      formal: 'Formalny',
      friendly: 'Przyjazny',
      persuasive: 'Przekonujący',
    },
    pricing: {
      title: 'Proste i Przejrzyste Ceny',
      subtitle: 'Wybierz plan odpowiedni dla Ciebie',
      free: 'Odkrycie',
      starter: 'Starter',
      pro: 'Pro',
      enterprise: 'Firmowy',
      perMonth: '/miesiąc',
      credits: 'kredytów',
      features: 'Funkcje',
      choosePlan: 'Wybierz',
      currentPlan: 'Aktualny plan',
      popular: 'Popularny',
    },
    news: {
      title: 'Centrum Aktualności',
      newFeatures: 'Nowe Funkcje',
      tips: 'Porady Marketingowe',
      rse: 'CSR & Ekologia',
      share: 'Udostępnij',
      loading: 'Ładowanie...',
    },
    admin: {
      title: 'Administracja',
      stats: 'Statystyki',
      users: 'Użytkownicy',
      analytics: 'Analityka',
      totalUsers: 'Razem użytkowników',
      totalRevenue: 'Całkowity przychód',
      mrr: 'MRR',
      arr: 'ARR',
      churn: 'Wskaźnik rezygnacji',
      ltv: 'LTV',
      arpu: 'ARPU',
      manageUser: 'Zarządzaj',
    },
    common: {
      loading: 'Ładowanie...',
      error: 'Błąd',
      success: 'Sukces',
      cancel: 'Anuluj',
      save: 'Zapisz',
      delete: 'Usuń',
      edit: 'Edytuj',
      close: 'Zamknij',
      back: 'Wstecz',
      next: 'Dalej',
      yes: 'Tak',
      no: 'Nie',
      or: 'lub',
    },
    footer: {
      rights: 'Wszelkie prawa zastrzeżone',
      privacy: 'Prywatność',
      terms: 'Regulamin',
    },
    features: {
      aiTitle: 'AI Specjalizująca się w Marketingu',
      aiDesc: 'Zoptymalizowane algorytmy do tworzenia treści, które konwertują. Każdy tekst jest zaprojektowany, aby angażować Twoją publiczność.',
      aiFeature1: 'Automatyczna optymalizacja SEO',
      aiFeature2: 'Ton dostosowany do Twojej marki',
      aiFeature3: 'Zoptymalizowana struktura H1-H3',
      ecoTitle: 'Zaangażowanie Ekologiczne',
      ecoDesc: 'Każda wygenerowana treść przyczynia się do naszego pozytywnego wpływu. Sadzimy drzewa i kompensujemy nasz ślad węglowy.',
      ecoFeature1: '1 drzewo zasadzone / 100 treści',
      ecoFeature2: 'Serwery eco-odpowiedzialne',
      ecoFeature3: 'Przejrzysty bilans węglowy',
    },
    stats: {
      contentTypes: 'Typy treści',
      contentTypesDesc: 'Blog, Social, Email...',
      madeInFrance: 'Made in France',
      madeInFranceDesc: 'Projekt francuski',
      aiGeneration: 'Najnowsza generacja',
      aiGenerationDesc: 'Zoptymalizowany GPT-4',
      support: 'Gwarantowane wsparcie',
      supportDesc: 'Francuski zespół',
    },
    transparency: {
      sectionTitle: 'Przejrzystość',
      title: 'Nasze zobowiązanie',
      subtitle: 'Żadnych fałszywych opinii. Tylko fakty.',
      realData: 'Prawdziwe dane',
      realDataDesc: 'Żadnych wymyślonych statystyk',
      rgpd: 'Zgodny',
      rgpdDesc: 'Twoje dane chronione',
      verified: 'Zweryfikowany',
      verifiedDesc: 'Wpływ ekologiczny',
      verifiedPartner: 'Certyfikowane partnerstwo',
      message: 'VF Actions to projekt w rozwoju. Budujemy naszą społeczność z',
      transparency: 'przejrzystością',
      and: 'i',
      authenticity: 'autentycznością',
      testimonialNote: 'Opinie będą dodawane w miarę otrzymywania prawdziwych informacji zwrotnych od naszych użytkowników.',
      ctaButton: 'Dołącz do pierwszych użytkowników',
      ctaSubtext: 'Bez zobowiązań • Przyczyń się do naszego rozwoju',
    },
  },

  ru: {
    nav: {
      dashboard: 'Панель',
      actualites: 'Новости',
      pricing: 'Цены',
      admin: 'Админ',
      login: 'Войти',
      register: 'Регистрация',
      logout: 'Выход',
    },
    hero: {
      badge: 'VF ACTIONS - Маркетинговое Решение с ИИ',
      title1: 'Автоматизируйте Создание Контента',
      title2: 'с помощью ИИ',
      subtitle: 'Создавайте профессиональный маркетинговый контент за секунды. Блог, соцсети, email - всё возможно с VF ACTIONS.',
      cta: 'Начать сейчас',
      ctaLogin: 'Перейти в Панель',
    },
    auth: {
      loginTitle: 'Вход',
      registerTitle: 'Создать аккаунт',
      email: 'Email',
      password: 'Пароль',
      name: 'Полное имя',
      forgotPassword: 'Забыли пароль?',
      loginBtn: 'Войти',
      registerBtn: 'Регистрация',
      switchToRegister: 'Создать аккаунт',
      switchToLogin: 'Войти',
      orContinueWith: 'Или продолжить через',
      googleLogin: 'Google',
      passwordRequirements: '8+ символов, заглавная, строчная, цифра',
      loginSuccess: 'Вход выполнен!',
      registerSuccess: 'Аккаунт создан! Проверьте email.',
      loginError: 'Ошибка входа',
      registerError: 'Ошибка регистрации',
    },
    dashboard: {
      welcome: 'Добро пожаловать',
      credits: 'Кредиты',
      plan: 'План',
      generate: 'Создать Контент',
      history: 'История',
      templates: 'Шаблоны',
      contentType: 'Тип контента',
      topic: 'Тема',
      tone: 'Тон',
      wordCount: 'Количество слов',
      industry: 'Индустрия',
      instructions: 'Дополнительные инструкции',
      generateBtn: 'Создать',
      generating: 'Создание...',
      result: 'Результат',
      copy: 'Копировать',
      save: 'Сохранить',
      noCredits: 'Нет кредитов',
    },
    contentTypes: {
      blog: 'Статья в Блог',
      social: 'Пост в Соцсети',
      email: 'Маркетинговый Email',
      ad: 'Реклама',
      description: 'Описание Товара',
    },
    tones: {
      professional: 'Профессиональный',
      casual: 'Неформальный',
      formal: 'Формальный',
      friendly: 'Дружелюбный',
      persuasive: 'Убедительный',
    },
    pricing: {
      title: 'Простые и Прозрачные Цены',
      subtitle: 'Выберите подходящий план',
      free: 'Ознакомление',
      starter: 'Стартер',
      pro: 'Про',
      enterprise: 'Корпоративный',
      perMonth: '/месяц',
      credits: 'кредитов',
      features: 'Функции',
      choosePlan: 'Выбрать',
      currentPlan: 'Текущий план',
      popular: 'Популярный',
    },
    news: {
      title: 'Центр Новостей',
      newFeatures: 'Новые Функции',
      tips: 'Маркетинговые Советы',
      rse: 'КСО & Экология',
      share: 'Поделиться',
      loading: 'Загрузка...',
    },
    admin: {
      title: 'Администрирование',
      stats: 'Статистика',
      users: 'Пользователи',
      analytics: 'Аналитика',
      totalUsers: 'Всего пользователей',
      totalRevenue: 'Общий доход',
      mrr: 'MRR',
      arr: 'ARR',
      churn: 'Показатель оттока',
      ltv: 'LTV',
      arpu: 'ARPU',
      manageUser: 'Управлять',
    },
    common: {
      loading: 'Загрузка...',
      error: 'Ошибка',
      success: 'Успех',
      cancel: 'Отмена',
      save: 'Сохранить',
      delete: 'Удалить',
      edit: 'Редактировать',
      close: 'Закрыть',
      back: 'Назад',
      next: 'Далее',
      yes: 'Да',
      no: 'Нет',
      or: 'или',
    },
    footer: {
      rights: 'Все права защищены',
      privacy: 'Конфиденциальность',
      terms: 'Условия',
    },
    features: {
      aiTitle: 'ИИ для Маркетинга',
      aiDesc: 'Оптимизированные алгоритмы для создания конвертирующего контента. Каждый текст разработан для вовлечения вашей аудитории.',
      aiFeature1: 'Автоматическая SEO-оптимизация',
      aiFeature2: 'Тон адаптирован к вашему бренду',
      aiFeature3: 'Оптимизированная структура H1-H3',
      ecoTitle: 'Экологическая Ответственность',
      ecoDesc: 'Каждый созданный контент вносит вклад в наше позитивное влияние. Мы сажаем деревья и компенсируем углеродный след.',
      ecoFeature1: '1 дерево посажено / 100 контентов',
      ecoFeature2: 'Эко-ответственные серверы',
      ecoFeature3: 'Прозрачный углеродный баланс',
    },
    stats: {
      contentTypes: 'Типы контента',
      contentTypesDesc: 'Блог, Соцсети, Email...',
      madeInFrance: 'Сделано во Франции',
      madeInFranceDesc: 'Французский дизайн',
      aiGeneration: 'Последнее поколение',
      aiGenerationDesc: 'Оптимизированный GPT-4',
      support: 'Гарантированная поддержка',
      supportDesc: 'Французская команда',
    },
    transparency: {
      sectionTitle: 'Прозрачность',
      title: 'Наше обязательство',
      subtitle: 'Никаких поддельных отзывов. Только факты.',
      realData: 'Реальные данные',
      realDataDesc: 'Никаких выдуманных статистик',
      rgpd: 'Соответствует',
      rgpdDesc: 'Ваши данные защищены',
      verified: 'Проверено',
      verifiedDesc: 'Экологическое влияние',
      verifiedPartner: 'Сертифицированное партнёрство',
      message: 'VF Actions - это развивающийся проект. Мы строим наше сообщество с',
      transparency: 'прозрачностью',
      and: 'и',
      authenticity: 'подлинностью',
      testimonialNote: 'Отзывы будут добавлены по мере получения реальной обратной связи от наших пользователей.',
      ctaButton: 'Присоединитесь к первым пользователям',
      ctaSubtext: 'Без обязательств • Внесите вклад в наше развитие',
    },
  },
};

export default translations;
